// // Convertit "178", "178,5", "178 cm" -> nombre JS fiable, sinon null
// export default function normalizeNumber(v) {
//     if (v === null || v === undefined) return null;
//     const s = String(v).replace(",", ".").replace(/[^\d.]/g, "");
//     const n = parseFloat(s);
//     return Number.isFinite(n) ? n : null;
//   }
  // Convertit "178", "178,5", "178 cm", "22.00" -> nombre JS fiable, sinon null
// Ex: "22.00" → 22 | "22.50" → 22.5 | "120/80" → "120/80" (BP inchangé)
// Convertit "178", "178,5", "178 cm", "22.00" -> nombre JS fiable, sinon null
// "22.00" → 22 | "22.50" → 22.5 | null/undefined → null
export default function normalizeNumber(v) {
  if (v === null || v === undefined) return null;
  const s = String(v).replace(",", ".").replace(/[^\d.]/g, "");
  const n = parseFloat(s);
  // parseFloat supprime automatiquement les zéros inutiles : 22.00 → 22, 22.50 → 22.5
  return Number.isFinite(n) ? n : null;
}